<!-- Child Selector pill (glass pill) -->
<div
  class="glass-card flex items-center rounded-full overflow-hidden max-w-[240px] sm:max-w-none mb-0 p-1.5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]! dark:shadow-[0_2px_8px_rgba(0,0,0,0.4)]!"
>
  <!-- Scrollable section: Todos + children -->
  <div
    class="flex items-center overflow-x-auto rounded-full [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden flex-1 min-w-0"
  >
    <!-- 'Todos' Button — only when multiple children -->
    @if (children().length > 1) {
    <button
      #todosBtn
      class="flex-shrink-0 flex items-center gap-2 px-3 lg:px-4 py-2 rounded-full text-sm transition-all duration-200 cursor-pointer"
      [class.bg-white]="!selectedId()"
      [class.dark:bg-white/15]="!selectedId()"
      [class.shadow-sm]="!selectedId()"
      [class.font-bold]="!selectedId()"
      [class.text-slate-800]="!selectedId()"
      [class.dark:text-white]="!selectedId()"
      [class.font-medium]="!!selectedId()"
      [class.text-slate-500]="!!selectedId()"
      [class.dark:text-slate-300]="!!selectedId()"
      (click)="selectChild('', todosBtn)"
    >
      <span class="material-symbols-outlined text-xl">all_inclusive</span>
    </button>
    } @for (child of children(); track child.id) {
    <button
      #childBtn
      class="flex-shrink-0 flex items-center gap-2 px-3 lg:px-4 py-2 rounded-full text-sm transition-all duration-200 cursor-pointer"
      [class.bg-white]="child.id === selectedId()"
      [class.dark:bg-white/15]="child.id === selectedId()"
      [class.shadow-sm]="child.id === selectedId()"
      [class.font-bold]="child.id === selectedId()"
      [class.text-slate-800]="child.id === selectedId()"
      [class.dark:text-white]="child.id === selectedId()"
      [class.font-medium]="child.id !== selectedId()"
      [class.text-slate-500]="child.id !== selectedId()"
      [class.dark:text-slate-300]="child.id !== selectedId()"
      (click)="selectChild(child.id, childBtn)"
    >
      @if (child.photoURL) {
      <img
        class="w-6 h-6 rounded-full object-cover"
        [src]="child.photoURL"
        [alt]="child.name"
      />
      } @else {
      <span
        class="w-6 h-6 rounded-full bg-primary/15 dark:bg-primary/25 text-primary text-[11px] font-bold flex items-center justify-center uppercase leading-none"
        >{{ child.name.charAt(0) }}</span
      >
      }
      <span>{{ child.name }}</span>
    </button>
    }
  </div>

  <!-- Add button: optionally visible, outside the scroll area -->
  @if (showAddButton()) {
  <button
    class="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full text-slate-500 dark:text-slate-300 cursor-pointer hover:text-primary hover:bg-white/20 transition-all"
    (click)="addAction.emit()"
  >
    <span class="material-symbols-outlined text-xl">add</span>
  </button>
  }
</div>
